module.exports = __webpack_public_path__ + "static/media/Sports.13d584d5.webp";